<template>
  <div v-if="loading">
	  <Loading />
  </div>
  <div v-else class="w-screen" :class="[containerClass]" @click="onDocumentClick">

    <div class="topbar">

      <AppTopbar
id="apptopbar" :topbar-menu-active="topbarMenuActive" :active-topbar-item="activeTopbarItem"
        :inline-user="inlineUser" :show-icons="false" :show-search="false"
        @right-menubutton-click="onRightMenuButtonClick" @menubutton-click="onMenuButtonClick"
        @topbar-menubutton-click="onTopbarMenuButtonClick" @topbar-item-click="onTopbarItemClick"
        @logout-button-click="onLogout" />
    </div>

    <div v-if="showLogoutModal" class="logout-modal">
      <LogoutConfirmation :display="true" @cancel-logout="onCancelLogout" @confirm-logout="onConfirmLogout" />
    </div>

    <AppRightMenu :right-panel-menu-active="rightPanelMenuActive" @rightmenu-click="onRightMenuClick"/>

    <transition name="layout-menu-container">
      <div v-show="isMenuVisible()" class="layout-menu-container" @click="onMenuClick">
        <div class="menu-scroll-content">
          <div v-if="inlineUser" class="layout-profile">
            <button class="p-link layout-profile-button" @click="onInlineUserClick">
              <img src="~/assets/images/avatar.jpg" alt="roma-layout" >
              <span class="layout-profile-userinfo">
                <span class="layout-profile-name">Arlene Welch</span>
                <span class="layout-profile-role">Design Ops</span>
              </span>
            </button>
            <transition name="layout-profile-menu">
              <ul
v-show="inlineUserMenuActive"
                :class="['layout-profile-menu', { 'profile-menu-active': inlineUserMenuActive }]">
                <li>
                  <button class="p-link"><i class="pi pi-fw pi-user"/><span>Profile teste</span></button>
                </li>
                <li>
                  <button class="p-link"><i class="pi pi-fw pi-cog"/><span>Settings</span></button>
                </li>
                <li>
                  <button class="p-link"><i class="pi pi-fw pi-envelope"/><span>Messages</span></button>
                </li>
                <li>
                  <button class="p-link"><i class="pi pi-fw pi-bell"/><span>Notifications</span></button>
                </li>
              </ul>
            </transition>
          </div>
          <AppMenu
:model="pageStore.isCollector() === true ? menuCollector : menuStation" :layout-mode="layoutMode"
            :active="menuActive" :mobile-menu-active="staticMenuMobileActive" @menuitem-click="onMenuItemClick"
            @root-menuitem-click="onRootMenuItemClick"/>
        </div>
      </div>
    </transition>

    <div class="layout-main" :style="'padding-top:' + apptopbarheight + 'px'">
      <div class="layout-content">
        <slot />
      </div>

    </div>

    <div class="layout-content-mask"/>
  </div>
</template>
<script lang="ts" setup>
// import { useToast } from 'primevue/usetoast';
// import { usePrimeVue } from "primevue/config";
import { menuCollector, menuStation } from "@/data";
import { computed, ref, watch } from 'vue';
const apptopbarheight = ref(0);

// stores
const pageStore = usePageStore()
const userStore = useUserStore()
const allowedMenusStore = useAllowedMenus()
const { logout } = useSessionManager()

const route = ref(useRouter());
const currentRoute = useRoute();
const showLogoutModal = ref(false)

const toast = useToast()
const primeVue = usePrimeVue()
const { $eventBus } = useNuxtApp()

const layoutMode = ref<string | undefined>('static');
const lightMenu = ref<boolean | null>(true);
const overlayMenuActive = ref(false);
const staticMenuMobileActive = ref(false);
const staticMenuDesktopInactive = ref(false);
const isRTL = ref<boolean | null>(false);
const inlineUser = ref<boolean | null>(false);
const topbarMenuActive = ref(false);
const activeTopbarItem = ref<string>("null");
const rightPanelMenuActive = ref(false);
const inlineUserMenuActive = ref(false);
const menuActive = ref(false);
const topbarColor = ref<string | null>('layout-topbar-blue');
const topbarItemClick = ref(false);
const rightMenuClick = ref(false);
const userMenuClick = ref(false);
const menuClick = ref(false);
const theme = ref<string>('blue');
const loading = ref<boolean>(false);

const topbarColors: any[] | null = [
  { name: 'Light', topbarColor: 'layout-topbar-light', logo: 'logo-roma', color: '#ffffff' },
  { name: 'Dark', topbarColor: 'layout-topbar-dark', logo: 'logo-roma-white', color: '#252529' },
  { name: 'Blue', topbarColor: 'layout-topbar-blue', logo: 'logo-roma-white', color: '#0772B3' },
  { name: 'Green', topbarColor: 'layout-topbar-green', logo: 'logo-roma-white', color: '#0F8C50' },
  { name: 'Orange', topbarColor: 'layout-topbar-orange', logo: 'logo-roma-white', color: '#C76D09' },
  {
    name: 'Magenta',
    topbarColor: 'layout-topbar-magenta',
    logo: 'logo-roma-white',
    color: '#972BB1',
  },
  {
    name: 'Blue Grey',
    topbarColor: 'layout-topbar-bluegrey',
    logo: 'logo-roma-white',
    color: '#406E7E',
  },
  {
    name: 'Deep Purple',
    topbarColor: 'layout-topbar-deeppurple',
    logo: 'logo-roma-white',
    color: '#543CD9',
  },
  { name: 'Brown', topbarColor: 'layout-topbar-brown', logo: 'logo-roma-white', color: '#794F36' },
  { name: 'Lime', topbarColor: 'layout-topbar-lime', logo: 'logo-roma-white', color: '#849201' },
  { name: 'Rose', topbarColor: 'layout-topbar-rose', logo: 'logo-roma-white', color: '#8F3939' },
  { name: 'Cyan', topbarColor: 'layout-topbar-cyan', logo: 'logo-roma-white', color: '#0C8990' },
  { name: 'Teal', topbarColor: 'layout-topbar-teal', logo: 'logo-roma-white', color: '#337E59' },
  {
    name: 'Deep Orange',
    topbarColor: 'layout-topbar-deeporange',
    logo: 'logo-roma-white',
    color: '#D74A1D',
  },
  { name: 'Indigo', topbarColor: 'layout-topbar-indigo', logo: 'logo-roma-white', color: '#3D53C9' },
  { name: 'Pink', topbarColor: 'layout-topbar-pink', logo: 'logo-roma-white', color: '#BF275B' },
  { name: 'Purple', topbarColor: 'layout-topbar-purple', logo: 'logo-roma-white', color: '#7F32DA' },
];

const themeColors: { name: string, file: string, color: string }[] | null = [
  { name: 'Blue', file: 'blue', color: '#0f97c7' },
  { name: 'Blue Grey', file: 'bluegrey', color: '#578697' },
  { name: 'Brown', file: 'brown', color: '#97664A' },
  { name: 'Cyan', file: 'cyan', color: '#1BA7AF' },
  { name: 'Deep Orange', file: 'deeporange', color: '#F96F43' },
  { name: 'Deep Purple', file: 'deeppurple', color: '#6952EC' },
  { name: 'Green', file: 'green', color: '#10B163' },
  { name: 'Teal', file: 'teal', color: '#4EA279' },
  { name: 'Indigo', file: 'indigo', color: '#435AD8' },
  { name: 'Lime', file: 'lime', color: '#A5B600' },
  { name: 'Magenta', file: 'magenta', color: '#B944D6' },
  { name: 'Orange', file: 'orange', color: '#E2841A' },
  { name: 'Pink', file: 'pink', color: '#E93A76' },
  { name: 'Purple', file: 'purple', color: '#9643F9' },
  { name: 'Rose', file: 'rose', color: '#AB5353' },
];


watch(route, () => {
  menuActive.value = false;
  toast.removeAllGroups();
});

function medirAlturaTopbar() {
  // Guarda de nulo: sem ela, um #apptopbar ausente lança e aborta o restante.
  const topbar = document.getElementById('apptopbar');
  apptopbarheight.value = topbar?.offsetHeight ?? 0;
}

onMounted(() => {
  // loading.value = true;

  // Define o modo de operação da tela.
  //
  // Sem esta chamada `pageStore.layout` permanece no valor inicial "main",
  // `isCollector()` nunca é verdadeiro e o layout serve sempre `menuStation` —
  // motivo pelo qual o menu do coletor e os botões auxiliares do topo não
  // apareciam em dispositivo móvel.
  //
  // `useIsMobile()` devolve um objeto de refs; testar o objeto direto seria
  // sempre verdadeiro, então é preciso ler `.value`.
  const { isMobileDevice } = useIsMobile();

  pageStore.setLayout(isMobileDevice.value ? "collector" : "default");

  // Mede depois do paint: no index a top bar fica mais alta (logo + versão
  // + empresa + usuário), e o valor inicial de 56px deixaria o menu sob o topo.
  nextTick(() => {
    medirAlturaTopbar();
    // Segundo frame: a marca do coletor home pode hidratar um tick depois.
    requestAnimationFrame(() => medirAlturaTopbar());
  });

  loading.value = false;
})

// Troca de rota (index ↔ rotina) muda a altura da top bar.
watch(
  () => currentRoute.fullPath,
  () => {
    nextTick(() => medirAlturaTopbar());
  },
);

onBeforeMount(() => {

})


async function onLogout(event: Event) {

  showLogoutModal.value = true

  event.preventDefault()
}

function onCancelLogout() {
  showLogoutModal.value = false
}

function onConfirmLogout() {
  userStore.setAuthStatus(false);
  useDeleteCookie('accessToken');
  showLogoutModal.value = false
  navigateTo("/login")
}


function onDocumentClick() {
  if (!topbarItemClick.value) {
    activeTopbarItem.value = "null";
    topbarMenuActive.value = false;
  }
  if (!rightMenuClick.value) {
    rightPanelMenuActive.value = false;
  }
  if (!userMenuClick.value && isSlim() && !isMobile()) {
    inlineUserMenuActive.value = false;
  }
  if (!menuClick.value) {
    if (isHorizontal() || isSlim()) {
      menuActive.value = false;
    }
    if (overlayMenuActive.value || staticMenuMobileActive) {
      hideOverlayMenu();
    }
    $eventBus.$emit('reset-active-index');
    unblockBodyScroll();
  }
  if (userMenuClick.value) {
    menuActive.value = false;
    $eventBus.$emit('reset-active-index');
  }

  topbarItemClick.value = false;
  menuClick.value = false;
  rightMenuClick.value = false;
  userMenuClick.value = false;
}

function onMenuButtonClick(event: Event) {
  menuClick.value = true;
  topbarMenuActive.value = false;
  rightPanelMenuActive.value = false;
  if (layoutMode.value === 'overlay') {
    overlayMenuActive.value = !overlayMenuActive.value;
  }
  if (isDesktop()) staticMenuDesktopInactive.value = !staticMenuDesktopInactive.value;
  else {
    staticMenuMobileActive.value = !staticMenuMobileActive.value;
    if (staticMenuMobileActive.value) {
      blockBodyScroll();
    } else {
      unblockBodyScroll();
    }
  }
  event.preventDefault();
}
function onTopbarMenuButtonClick(event: Event) {
  topbarItemClick.value = true;
  topbarMenuActive.value = !topbarMenuActive.value;
  hideOverlayMenu();
  event.preventDefault();
}
function onTopbarItemClick(event: { originalEvent: Event, item: string }) {
  topbarItemClick.value = true;
  if (activeTopbarItem.value === event.item) activeTopbarItem.value = "null";
  else activeTopbarItem.value = event.item;
  event.originalEvent.preventDefault();
}

function onMenuClick() {
  menuClick.value = true;
}
function onInlineUserClick() {
  userMenuClick.value = true;
  inlineUserMenuActive.value = !inlineUserMenuActive.value;
}
function blockBodyScroll() {
  addClass(document.body, 'blocked-scroll');
}
function unblockBodyScroll() {
  removeClass(document.body, 'blocked-scroll');
}
function onRightMenuButtonClick(event: any) {
  rightMenuClick.value = true;
  rightPanelMenuActive.value = !rightPanelMenuActive.value;
  hideOverlayMenu();
  event.preventDefault();
}
function onRightMenuClick() {
  rightMenuClick.value = true;
}
function hideOverlayMenu() {
  overlayMenuActive.value = false;
  staticMenuMobileActive.value = false;
}
function onMenuItemClick(event: any) {
  if (!event.item.items) {
    $eventBus.$emit('reset-active-index');
    hideOverlayMenu();
  }
  if (!event.item.items && (isHorizontal() || isSlim())) {
    menuActive.value = false;
  }
}
function onRootMenuItemClick() {
  menuActive.value = !menuActive.value;
}
/*function isTablet() {
    if(process.client){
    let width = window.innerWidth;
    return width <= 1024 && width > 640;
    }
  }*/
function isDesktop() {
  if (import.meta.client) {
    return window.innerWidth > 896;
  }
}
function isMobile() {
  if (import.meta.client) {
    return window.innerWidth <= 1025;
  }
}
function isHorizontal() {
  return layoutMode.value === 'horizontal';
}
function isSlim() {
  return layoutMode.value === 'slim';
}
function isMenuVisible() {
  if (isDesktop()) {
    if (layoutMode.value === 'static') return !staticMenuDesktopInactive.value;
    else if (layoutMode.value === 'overlay') return overlayMenuActive.value;
    else return true;
  } else {
    return true;
  }
}
function onLayoutChange(p_layoutMode: any) {
  layoutMode.value = p_layoutMode;
  staticMenuDesktopInactive.value = false;
  overlayMenuActive.value = false;
  if (isSlim() || isHorizontal()) {
    inlineUser.value = false;
    inlineUserMenuActive.value = false;
  }
}
function onMenuColorChange(menuColor: any) {
  lightMenu.value = menuColor;
}
function onProfileModeChange(profileMode: any) {
  inlineUser.value = profileMode;
}
function onChangeOrientation(orientation: any) {
  isRTL.value = orientation;
}
function onTopbarColorChange(p_topbarColor: any, logo: any) {
  topbarColor.value = p_topbarColor;
  const topbarLogoLink: any = document.getElementById('topbar-logo');
  topbarLogoLink.src = '../assets/images/' + logo + '.svg';
}

/**
 * TROCA DE TEMA DESABILITADA PARA PERFORMANCE
 * Apenas theme-blue está carregado no sistema
 */

// function onThemeChange(p_theme: string) {
//   theme.value = p_theme;
//   changeStyleSheetUrl('layout-css', theme.value, 'layout');
//   changeStyleSheetUrl('theme-css', theme.value, 'theme');
// }
// function changeStyleSheetUrl(id: string, value: string, prefix: string) {
//   const element: any = document.getElementById(id);
//   const urlTokens = element.getAttribute('href').split('/');
//   urlTokens[urlTokens.length - 1] = prefix + '-' + value + '.css';
//   const newURL = urlTokens.join('/');
//   replaceLink(element, newURL);
// }
// function replaceLink(linkElement: any, href: any) {
//   const id = linkElement.getAttribute('id');
//   const cloneLinkElement = linkElement.cloneNode(true);
//   cloneLinkElement.setAttribute('href', href);
//   cloneLinkElement.setAttribute('id', id + '-clone');
//   cloneLinkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);
//   cloneLinkElement.addEventListener('load', () => {
//     linkElement.remove();
//     cloneLinkElement.setAttribute('id', id);
//   });
// }
function addClass(element: any, className: string) {
  if (element.classList) element.classList.add(className);
  else element.className += ' ' + className;
}
function removeClass(element: any, className: string) {
  if (element.classList) element.classList.remove(className);
  else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}
const containerClass = computed(() => [
  'layout-wrapper',
  {
    'layout-horizontal': layoutMode.value === 'horizontal',
    'layout-overlay': layoutMode.value === 'overlay',
    'layout-static': layoutMode.value === 'static',
    'layout-slim': layoutMode.value === 'slim',
    'layout-menu-light': lightMenu.value === true,
    'layout-menu-dark': lightMenu.value === false,
    'layout-overlay-active': overlayMenuActive.value,
    'layout-mobile-active': staticMenuMobileActive.value,
    'layout-static-inactive': staticMenuDesktopInactive.value,
    'layout-rtl': isRTL.value,
    'p-input-filled': primeVue.config.inputStyle === 'filled',
    'p-ripple-disabled': primeVue.config.ripple === false,
  },
  topbarColor.value,

]);

</script>
